import React, { Component } from 'react';
import { connect } from 'react-redux';
import BaseModal from '../BaseModal';
import EditShippingForm from './EditShippingForm';
import { editShipping } from 'actions/shippings';
import { findPurchase } from 'actions/purchases';
import Spinner from 'components/Spinner';

class EditShippingDetailsModal extends Component {
  state = {
    isOpen: false,
    loading: false,
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  handleEditShipping = (values) => {
    const { purchase, findPurchase, editShipping } = this.props;

    const params = {
      ...values,
      city_state: values.city + ', ' + values.state,
    };
    delete params.city;
    delete params.state;

    this.setState({ loading: true });
    return editShipping(purchase.shipping.id, params)
      .then(() => findPurchase(purchase.id))
      .then(() => {
        this.closeModal();
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  getInitialValues = () => {
    const { purchase } = this.props;
    const { shipping } = purchase || {};
    let city, state;
    if (
      shipping &&
      shipping.city_state &&
      shipping.city_state.indexOf(',') !== -1
    ) {
      const splittedCityState = shipping.city_state.split(',');
      city = splittedCityState[0].trim();
      state = splittedCityState[1].trim();
    }

    const initialValues = {
      full_name: shipping?.full_name || '',
      address1: shipping?.address1 || '',
      address2: shipping?.address2 || '',
      city: city || '',
      state: state || '',
      zip_code: shipping?.zip_code || '',
    };
    return initialValues;
  };

  render() {
    const { purchase, isB2b } = this.props;
    const { isOpen, loading } = this.state;
    const isEditable =
      !isB2b &&
      purchase &&
      purchase.shipping &&
      purchase.shipping.id &&
      ['pending', 'overdue', 'open', 'arranged'].includes(purchase.status);

    if (!isEditable) {
      return null;
    }

    const initialValues = this.getInitialValues();

    return (
      <React.Fragment>
        <button className="btn btn-default" onClick={this.openModal}>
          Edit Shipping Details
        </button>
        <BaseModal
          isOpen={isOpen}
          title="Edit Shipping Details"
          onClose={this.closeModal}
          confirmBtnText=""
          cancelBtnText=""
        >
          <EditShippingForm
            initialValues={initialValues}
            onSubmit={this.handleEditShipping}
          />
          <Spinner showLoader={loading} />
        </BaseModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  editShipping,
  findPurchase,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditShippingDetailsModal);
